// extracted by mini-css-extract-plugin
module.exports = {"list":"PaymentDrawer_list__OdwU4"};